<form [formGroup]="form" (ngSubmit)="submit()">
    <app-input *ngIf="!isVerified" formControlName="email" (focusout)="sendEvent('email')" label="Correo electrónico"></app-input>
    <app-input class="passwordInput" formControlName="actualPassword" encrypted="true" (focusout)="sendEvent('actualPassword')" label="Contraseña"></app-input>
    <a  class="forget-password" routerLink="forgot-password"  href="#">¿Olvidaste tu contraseña?</a>
    <div class="button-container">
        <fs-ui-button  [action]="'submit'" [label]="'Acceder'"></fs-ui-button>
    </div>
</form>
